import { SynchTripImportDTO } from 'business/models/Models';
import React, { useContext, useEffect, useState } from 'react';
import ImportSynchTripWizardContext from './importSynchTripWizardContext';
import { useCrystals } from 'redux/hooks/synchrotron';
import { CrystalContainerAssignments } from '../constants';
import { getUpdatedCrystalsAfterCrystalContainerAssignments } from '../puckDewarContainer/utils';
import { useRMDispatch } from 'redux/hooks';
import { setAllCrystals, setTripEditStatus } from 'redux/reducers/synchrotronTripReducer';
import SynchTripResultSummary from '../importSynchTripResult/importSummary';

interface recordsCountType {
  validRecords: number;
  invalidRecords: number;
  totalRecords: number;
}
const recordsCountInit = {
  validRecords: 0,
  invalidRecords: 0,
  totalRecords: 0,
};

const ImportDataSummaryPage = () => {
  const [recordsCount, setRecordsCount] = useState<recordsCountType>(recordsCountInit);
  const synchTripContext = useContext(ImportSynchTripWizardContext);

  const assignedCrystals = useCrystals();
  const dispatch = useRMDispatch();

  useEffect(() => {
    synchTripContext.setNextButtonDisallowed(false);

    updateSummary();

    importData();
  }, []);

  const updateSummary = () => {
    const tripList: SynchTripImportDTO[] = synchTripContext.synchTripImportDTOList;
    const totalCount = tripList.length;
    const validCount = tripList.filter((t) => t.errorMessage == '').length;
    const invalidCount = tripList.filter((t) => t.errorMessage != '').length;

    setRecordsCount({
      validRecords: validCount,
      invalidRecords: invalidCount,
      totalRecords: totalCount,
    });
  };
  const importData = async () => {
    let updatedCrystals = assignedCrystals;

    synchTripContext.synchTripImportDTOList.forEach((st) => {
      if (!st.errorMessage?.length) {
        //valid import

        const container: CrystalContainerAssignments = {
          dewarId: st.dewarId,
          puckId: st.puckId,
          puckPinPosition: st.puckPinPosition,
          isUpdated: true,
        };

        updatedCrystals = getUpdatedCrystalsAfterCrystalContainerAssignments(
          updatedCrystals,
          st.crystalId,
          container,
        );
      }
    });

    dispatch(setAllCrystals(updatedCrystals));
    dispatch(setTripEditStatus({ isDirty: true }));
  };

  return (
    <div id="importdatasummarypage-wrapper" className="flex flex-column w-320">
      <SynchTripResultSummary
        importedRows={recordsCount.totalRecords}
        validRows={recordsCount.validRecords}
        inValidRows={recordsCount.invalidRecords}
      />
    </div>
  );
};

export default ImportDataSummaryPage;
